import { render } from "./AtletiDataTable.vue?vue&type=template&id=c093753e&scoped=true"
import script from "./AtletiDataTable.vue?vue&type=script&lang=js"
export * from "./AtletiDataTable.vue?vue&type=script&lang=js"

import "./AtletiDataTable.vue?vue&type=style&index=0&id=c093753e&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c093753e"]])

export default __exports__